<template>
  <v-container
    fluid
    grid-list-md
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <material-card
      :title="$t('views.contributionswizard.import_employer_contributions')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="mediation"
    >
      <v-card-text>
        <contributions-wizard/>
      </v-card-text>
    </material-card>
    <error-handler :error="error"></error-handler>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
import ErrorHandler from "../components/ErrorHandler";
import ContributionsWizard from "../components/ContributionsControl/ContributionsWizard.vue";
export default {
  props:["planId"],
  data() {
    return {
      error: null,
    };
  },
  components: {
    ErrorHandler,
    ContributionsWizard
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
};
</script>
